<template>
  <div class="block-dark" :style="props.styles"></div>
</template>

<script lang="ts" setup>
  
    const props = defineProps(['styles'])
</script>

<style scoped>
  .block-dark {
    background-color: var(--bs-body-bg);
  }
</style>
